<div class="form-group row">
  <label class="col col-form-label"> &nbsp; </label>
</div>
